module.exports = __webpack_public_path__ + "img/ce0ddb6.png";